import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { CORE_QUERY_KEYS as INVENTORY_QUERY_KEYS } from 'app/hooks/data/core/extranet/inventory';
import type { CalendarPeriod } from 'app/typings/core/extranet/inventory/calendar';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useDeleteSlot(
  hotelId?: number,
  calendarId?: number,
  period?: CalendarPeriod
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (slotId: number) =>
      hotelId && calendarId
        ? (apiMutation('DELETE', {
            path: ENDPOINTS.deleteSlot,
            params: {
              hotelId: hotelId.toString(),
              calendarId: calendarId.toString(),
              slotId: slotId.toString(),
            },
            queryParams: {
              startDate: period?.startDate,
              endDate: period?.endDate,
            },
          }) as Promise<void>)
        : Promise.reject(null),
    onSuccess: () => {
      message.success('Slot successfully deleted');

      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.calendar, { hotelId, calendarId }],
      });

      queryClient.invalidateQueries({
        queryKey: [INVENTORY_QUERY_KEYS.inventory, { hotelId }],
      });
    },
    onError: () => {
      message.error('Failed to delete slot.');
    },
  });
}
